import React, {useState} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {cloneObject, textKeysReplacement} from '../../../tools/helpers';
import {Input} from 'antd';
import './style.scss';
import './mobile.scss';
import TextArea from 'antd/es/input/TextArea';
import Button from '../../Button';
import * as userRequests from '../../../actions/userRequestsActionCreators';
import InputPhone from '../../InputPhone';
import {useUnmount} from 'react-use';

let formTimeout = null;
const RubricAppearanceRequestForm = (props) => {
  const
    rubric = props.rubricsState.currentRubric;

  if (!rubric) {
    return;
  }

  const
    [formParams, setFormParams] = useState({
      name: '',
      phone: '',
      org: '',
      request: '',
      rubric_title: rubric.title
    }),

    {is_mobile} = props.applicationState,
    formText = rubric?.rubric_appearance?.form_text,
    mobileText = rubric?.rubric_appearance?.mobile_form_text ? rubric?.rubric_appearance?.mobile_form_text : formText,

    handleSubmit = () => {
      props.userRequestsActions.sendRubricRequestForm(formParams);
    },

    onChange = (attr) => (event) => {
      const values = {
        ...formParams,
        [attr]: attr === 'phone' ? event : event.target.value
      };

      setFormParams(values);
      clearTimeout(formTimeout);
      formTimeout = setTimeout(() => {
        props.userRequestsActions.changeRubricRequestForm(values);
      }, 800);
    };

  useUnmount(() => {
    props.userRequestsActions.changeRubricRequestForm({});
  });

  return (
    <div
      className='rubric-appearance-form__wrapper'
      style={{
        background: `linear-gradient(270deg, rgba(21, 54, 161, 0.35) 0%, rgba(75, 136, 255, 0.35) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8))`,
        backgroundImage: `url('${rubric.rubric_appearance.form_bg?.image}')`,
        backgroundPosition: '50% / cover',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className='rubric-appearance-form__col'>
        <div className='rubric-appearance-form__text'>
          {
            is_mobile ?
              <div className='html-content' data-raw-html dangerouslySetInnerHTML={{__html: textKeysReplacement(mobileText, props.applicationState.default_seo_context)}} />
              : <div className='html-content' data-raw-html dangerouslySetInnerHTML={{__html: textKeysReplacement(formText, props.applicationState.default_seo_context)}} />
          }
        </div>
      </div>

      <div className='rubric-appearance-form__col'>
        {
          props.userRequestsState.rubricRequestForm?.done ?
            <div className='rubric-appearance-form__box'>
              <div className='rubric-appearance-form__title'>Ваша заявка на {rubric.title} успешно отправлена.</div>
            </div>
            :
            <div className='rubric-appearance-form__box'>
              <div className='rubric-appearance-form__title'>Поможем подобрать {rubric.title}</div>
              <div className='rubric-appearance-form__items'>
                <form className='user-form'>
                  <div className={`user-form__row-input ${props.userRequestsState.rubricRequestForm?.errors?.name ? 'error' : ''}`}>
                    <Input placeholder='Фамилия Имя Отчество' maxLength={150} value={formParams.name} onChange={onChange('name')} />
                  </div>
                  <div className={`user-form__row-input ${props.userRequestsState.rubricRequestForm?.errors?.phone ? 'error' : ''}`}>
                    <InputPhone placeholder='Телефон' value={formParams.phone} onChange={onChange('phone')} />
                  </div>
                  <div className={`user-form__row-input ${props.userRequestsState.rubricRequestForm?.errors?.org ? 'error' : ''}`}>
                    <Input placeholder='Организация' maxLength={150} value={formParams.org} onChange={onChange('org')} />
                  </div>
                  <div className={`user-form__row-input ${props.userRequestsState.rubricRequestForm?.errors?.request ? 'error' : ''}`}>
                    <TextArea placeholder='Ваша заявка' maxLength={150} value={formParams.request} onChange={onChange('request')} />
                  </div>
                  <div className='user-form__row'>
                    <Button primary className='md w-full' onClick={handleSubmit} loader={!!props.userRequestsState.rubricRequestSending} >Отправить</Button>
                  </div>
                </form>
              </div>
            </div>
        }
      </div>
    </div>
  );
};

const
  mapDispatchToProps = (dispatch) => {
    return {
      userRequestsActions: bindActionCreators(userRequests, dispatch),
    };
  },
  mapStateToProps = ({applicationState, railsContext, rubricsState, userRequestsState}) => {
    return {
      userRequestsState,
      applicationState,
      railsContext,
      rubricsState
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default compose(withConnect)(RubricAppearanceRequestForm);
